import React, {createRef} from 'react';
import classnames from 'classnames';
import DocumentTitle from './contentShumaType3/DocumentTitle';
import DocProps from './contentShumaType3/DocProps';
import CustomerProps from './contentShumaType3/CustomerProps';
import Section1 from './contentShumaType3/Section1';
import Section2 from './contentShumaType3/Section2';
import Section3 from './contentShumaType3/Section3';
import Section4 from './contentShumaType3/Section4';
import Section5 from './contentShumaType3/Section5';
import Section6 from './contentShumaType3/Section6';
import Section7 from './contentShumaType3/Section7';
import Section8 from './contentShumaType3/Section8';
import Section9, * as Section9Assets from './contentShumaType3/Section9';
import Section10 from './contentShumaType3/Section10';
import Section11 from './contentShumaType3/Section11';
import Section12 from './contentShumaType3/Section12';
import Section13, * as Section13Assets from './contentShumaType3/Section13';
import Section14 from './contentShumaType3/Section14';
import Section15 from './contentShumaType3/Section15';
import Comments from './contentShumaType3/Comments';
import PageBreak from './contentShumaType3/PageBreak';
import {getFiles} from "./contentShumaType3/FilesArray";
import {findFileByTypeId} from "../../utils/files";
import {getFloors} from './contentShumaType3/Floors';
import {getAdjacentStreets} from './contentShumaType3/SectionAdjacentStreets';
import getValidLocalPlansDetailsSection from './contentShumaType3/ValidLocalPlansDetailsSection';
import getCountryStateDataSection from './contentShumaType3/CountryStateDataSection';
import getPlansInProgressSection from './contentShumaType3/PlansInProgressSection';
import styles from './styles.module.scss';
import contentStyles from './contentShumaType3/styles.module.scss';

let i = 0;

const mapItem = ({refs, id, getClassName}) => (item, index, array) => {
  const Component = React.forwardRef(({}, ref) => (
    <div
      ref={ref}
      data-testid={id}
      className={Boolean(getClassName) ? getClassName({index, array}) : ''}
    >
      {item}
    </div>
  ));

  return <Component ref={addRef(refs)} key={i++}/>;
};

export const getContentAndRefs = (context) => {
  let refs = [];
  let commentRefs = {};

  const Component = React.forwardRef(({page, file, index}, ref) => (
    <div
      ref={ref}
      className={classnames({
        [styles.pageHeight]: Boolean(file),
        // [styles.smallerHeight720]: index === 0 causes pdf 1st page be smaller
      })}
    >
      {page}
    </div>
  ));

  const content = [
    <DocProps ref={addRef(refs)} key={i++}/>,
    <DocumentTitle ref={addRef(refs)} key={i++}/>,
    <CustomerProps ref={addRef(refs)} key={i++}/>,
    <Section1 ref={addRef(refs)} key={i++}/>,
    <Section2 ref={addRef(refs)} key={i++}/>,
    <Section3 ref={addRef(refs)} key={i++}/>,
    <Section4 ref={addRef(refs)} key={i++}/>,
    <Section5.HeadLine1 ref={addRef(refs)} key={i++}/>,
    <Section5.Line2 ref={addRef(refs)} key={i++}/>,
    <Section5.Line3 ref={addRef(refs)} key={i++}/>,
    <Section5.Line4 ref={addRef(refs)} key={i++}/>,
    <Section6.HeadLine1 ref={addRef(refs)} key={i++}/>,
    ...getFiles(context, 'זיהוי הנכס לפי תשריט', 32).map((page, index) => {
        const file = findFileByTypeId(context.files, 32);
        return <Component page={page} file={file} index={index} ref={addRef(refs)} key={i++}/>;
      }),
    <Section6.Line3 ref={addRef(refs)} key={i++}/>,
    <Section6.Line3a ref={addRef(refs)} key={i++}/>,
    <Section6.Line4 ref={addRef(refs)} key={i++}/>,
    <Section6.Line18 ref={addRef(refs)} key={i++}/>,
    <Section6.Line5 ref={addRef(refs)} key={i++}/>,
    <Section6.Line6 ref={addRef(refs)} key={i++}/>,
    <Section6.Line7 ref={addRef(refs)} key={i++}/>,
    <Section6.Line8 ref={addRef(refs)} key={i++}/>,
    <Section6.Line9 ref={addRef(refs)} key={i++}/>,
    <Section6.Line10 ref={addRef(refs)} key={i++}/>,
    <Section6.Line11 ref={addRef(refs)} key={i++}/>,
    <Section6.Line12 ref={addRef(refs)} key={i++}/>,
    <Section6.Line13 ref={addRef(refs)} key={i++}/>,
    <Section6.Line14 ref={addRef(refs)} key={i++}/>,
    <Section6.Line14a ref={addRef(refs)} key={i++}/>,
    <Section6.Line15 ref={addRef(refs)} key={i++}/>,
    <Section6.Line16 ref={addRef(refs)} key={i++}/>,
    <Section6.Line17 ref={addRef(refs)} key={i++}/>,
    ...getFiles(context, '', 10, <Section7.HeadLine1/>).map((page, index) => {
      const file = findFileByTypeId(context.files, 10);
      return <Component page={page} file={file} index={index} ref={addRef(refs)} key={i++}/>;
    }),
    ...getFloors(context, 11, '', <Section7.HeadLine1/>)
      .map(mapItem({
        refs,
        id: 'getFloors',
        getClassName: ({index, array}) => classnames({[styles.mb5]: index === array.length - 1})
      })),
    <Section8.HeadLine1 ref={addRef(refs)} key={i++}/>,
    <Section8.Line3 ref={addRef(refs)} key={i++}/>,
    ...getAdjacentStreets(context).map(mapItem({
      refs,
      id: 'adjacentStreets'
    })),
    <Section8.Line4 ref={addRef(refs)} key={i++}/>,
    ...getFiles(context, 'מפת איתור הנכס', 2).map((page, index) => {
      const file = findFileByTypeId(context.files, 2);
      return <Component page={page} file={file} index={index} ref={addRef(refs)} key={i++}/>;
    }),
    <div ref={addRef(refs)}/>,
    ...getFiles(context, 'תצ"א', 8).map((page, index) => {
      const file = findFileByTypeId(context.files, 8);
      return <Component page={page} file={file} index={index} ref={addRef(refs)} key={i++}/>;
    }),
    <Section8.SubHead2 ref={addRef(refs)} key={i++}/>,
    <Section8.Line7 ref={addRef(refs)} key={i++}/>,
    <Section8.Line7a ref={addRef(refs)} key={i++}/>,
    <Section8.SubHead3 ref={addRef(refs)} key={i++}/>,
    <Section8.Line9 ref={addRef(refs)} key={i++}/>,
    <Section8.Line10 ref={addRef(refs)} key={i++}/>,
    <Section8.Line11 ref={addRef(refs)} key={i++}/>,
    <Section8.Line12 ref={addRef(refs)} key={i++}/>,
    <Section8.Line13 ref={addRef(refs)} key={i++}/>,
    <Section8.Line14 ref={addRef(refs)} key={i++}/>,
    <Section8.Line15 ref={addRef(refs)} key={i++}/>,
    <Section8.Line16a ref={addRef(refs)} key={i++}/>,
    <Section8.Line16c ref={addRef(refs)} key={i++}/>,
    <Section8.Line16 ref={addRef(refs)} key={i++}/>,
    <Section8.Line16b ref={addRef(refs)} key={i++}/>,
    <Section8.Line17 ref={addRef(refs)} key={i++}/>,
    <Section8.Line18 ref={addRef(refs)} key={i++}/>,
    <Section8.Line19 ref={addRef(refs)} key={i++}/>,
    <Section8.Line20 ref={addRef(refs)} key={i++}/>,
    <Section8.Line21 ref={addRef(refs)} key={i++}/>,
    <Section9.HeadLine1 ref={addRef(refs)} key={i++}/>,
    <Section9.Line01 ref={addRef(refs)} key={i++}/>,
    <Section9.Line02 ref={addRef(refs)} key={i++}/>,
    <Section9.Line03 ref={addRef(refs)} key={i++}/>,
    <Section9.Line04 ref={addRef(refs)} key={i++}/>,
    <Section9.Line05 ref={addRef(refs)} key={i++}/>,
    <Section9.Line06 ref={addRef(refs)} key={i++}/>,
    <Section9.Line1 ref={addRef(refs)} key={i++}/>,
    <Section9.Line2 ref={addRef(refs)} key={i++}/>,
    <Section9.Line3a ref={addRef(refs)} key={i++}/>,
    <Section9.Line3b ref={addRef(refs)} key={i++}/>,
    ...Section9Assets.getLine4Content(context).map(mapItem({
      refs,
      id: 'Section9Assets.getLine4Content',
      getClassName: () => classnames(
        contentStyles.textRegular,
        contentStyles.sectionContainer,
        contentStyles.innerPadding
      )
    })),
    <Section9.Line5 ref={addRef(refs)} key={i++}/>,
    <Section9.Line6 ref={addRef(refs)} key={i++}/>,
    <Section9.Line7 ref={addRef(refs)} key={i++}/>,
    <Section9.Line8 ref={addRef(refs)} key={i++}/>,
    <Section9.Line9 ref={addRef(refs)} key={i++}/>,
    <Section9.Line10 ref={addRef(refs)} key={i++}/>,
    <Section9.Line11 ref={addRef(refs)} key={i++}/>,
    <Section9.Line11a ref={addRef(refs)} key={i++}/>,
    <Section9.Line12 ref={addRef(refs)} key={i++}/>,
    <Section9.Line13 ref={addRef(refs)} key={i++}/>,
    <Section9.Line14 ref={addRef(refs)} key={i++}/>,
    <Section9.Line15 ref={addRef(refs)} key={i++}/>,
    <Section9.Line16 ref={addRef(refs)} key={i++}/>,
    <Section9.Line17 ref={addRef(refs)} key={i++}/>,
    <Section9.Line18 ref={addRef(refs)} key={i++}/>,
    <Section9.Line19 ref={addRef(refs)} key={i++}/>,
    <Section9.Line20 ref={addRef(refs)} key={i++}/>,
    <Section9.Line21 ref={addRef(refs)} key={i++}/>,
    <Section9.Line22 ref={addRef(refs)} key={i++}/>,
    ...getFiles(context, 'שרטוט הנכס:', 33).map((page, index) => {
      const file = findFileByTypeId(context.files, 33);
      return <Component page={page} file={file} index={index} ref={addRef(refs)} key={i++}/>;
    }),
    <Section10.HeadLine1 ref={addRef(refs)} key={i++}/>,
    ...getFiles(context, 'קובץ תכניות בתוקף:', 14).map((page, index) => {
      const file = findFileByTypeId(context.files, 14);
      return <Component page={page} file={file} index={index} ref={addRef(refs)} key={i++}/>;
    }),
    ...getValidLocalPlansDetailsSection(context).map(mapItem({
      refs,
      id: 'getValidLocalPlansDetailsSection'
    })),
    ...getCountryStateDataSection(context).map(mapItem({
      refs,
      id: 'getCountryStateDataSection'
    })),
    ...getPlansInProgressSection(context).map(mapItem({
      refs,
      id: 'getPlansInProgressSection'
    })),
    <Section10.Line1a ref={addRef(refs)} key={i++}/>,
    ...getFiles(context, '', 5).map((page, index) => {
      const file = findFileByTypeId(context.files, 5);
      return <Component page={page} file={file} index={index} ref={addRef(refs)} key={i++}/>;
    }),
    <Section10.Line2a ref={addRef(refs)} key={i++}/>,
    ...getFiles(context, '', 6).map((page, index) => {
      const file = findFileByTypeId(context.files, 6);
      return <Component page={page} file={file} index={index} ref={addRef(refs)} key={i++}/>;
    }),
    <Section10.Line3a ref={addRef(refs)} key={i++}/>,
    ...getFiles(context, '', 7).map((page, index) => {
      const file = findFileByTypeId(context.files, 7);
      return <Component page={page} file={file} index={index} ref={addRef(refs)} key={i++}/>;
    }),
    <Section10.Line4a ref={addRef(refs)} key={i++}/>,
    ...getFiles(context, '', 26).map((page, index) => {
      const file = findFileByTypeId(context.files, 26);
      return <Component page={page} file={file} index={index} ref={addRef(refs)} key={i++}/>;
    }),
    <Section10.SubHeaderLine2 ref={addRef(refs)} key={i++}/>,
    <Section10.Line3 ref={addRef(refs)} key={i++}/>,
    <Section10.Line4 ref={addRef(refs)} key={i++}/>,
    <Section10.Line5 ref={addRef(refs)} key={i++}/>,
    <Section10.Line6 ref={addRef(refs)} key={i++}/>,
    <Section10.Line7 ref={addRef(refs)} key={i++}/>,
    <Section10.Line8 ref={addRef(refs)} key={i++}/>,
    ...getFiles(context, '', 22).map((page, index) => {
      const file = findFileByTypeId(context.files, 22);
      return <Component page={page} file={file} index={index} ref={addRef(refs)} key={i++}/>;
    }),
    <Section10.Line9 ref={addRef(refs)} key={i++}/>,
    ...getFiles(context, '', 23).map((page, index) => {
      const file = findFileByTypeId(context.files, 23);
      return <Component page={page} file={file} index={index} ref={addRef(refs)} key={i++}/>;
    }),
    <Section10.Line10 ref={addRef(refs)} key={i++}/>,
    ...getFiles(context, '', 24).map((page, index) => {
      const file = findFileByTypeId(context.files, 24);
      return <Component page={page} file={file} index={index} ref={addRef(refs)} key={i++}/>;
    }),
    ...getFiles(context, 'תשריט הדירה מתוך היתר הבניה', 13).map((page, index) => {
      const file = findFileByTypeId(context.files, 13);
      return <Component page={page} file={file} index={index} ref={addRef(refs)} key={i++}/>;
    }),
    <Section11.HeadLine1 ref={addRef(refs)} key={i++}/>,
    <Section11.Line2 ref={addRef(refs)} key={i++}/>,
    <Section11.SubHead1 ref={addRef(refs)} key={i++}/>,
    <Section11.Line4 ref={addRef(refs)} key={i++}/>,
    ...getFiles(context, '', 1).map((page, index) => {
      const file = findFileByTypeId(context.files, 1);
      return <Component page={page} file={file} index={index} ref={addRef(refs)} key={i++}/>;
    }),
    <Section11.Line6 ref={addRef(refs)} key={i++}/>,
    <Section11.Line7 ref={addRef(refs)} key={i++}/>,
    ...getFiles(context, '', 16).map((page, index) => {
      const file = findFileByTypeId(context.files, 16);
      return <Component page={page} file={file} index={index} ref={addRef(refs)} key={i++}/>;
    }),
    <div ref={addRef(refs)}/>,
    ...getFiles(context, '', 25).map((page, index) => {
      const file = findFileByTypeId(context.files, 25);
      return <Component page={page} file={file} index={index} ref={addRef(refs)} key={i++}/>;
    }),
    <Section11.SubHeadLine2 ref={addRef(refs)} key={i++}/>,
    <Section11.Line9 ref={addRef(refs)} key={i++}/>,
    <Section11.Line10 ref={addRef(refs)} key={i++}/>,
    <Section11.Line11 ref={addRef(refs)} key={i++}/>,
    ...getFiles(context, 'קובץ:', 4).map((page, index) => {
      const file = findFileByTypeId(context.files, 4);
      return <Component page={page} file={file} index={index} ref={addRef(refs)} key={i++}/>;
    }),
    <Section11.Line13 ref={addRef(refs)} key={i++}/>,
    ...getFiles(context, 'קובץ:', 3).map((page, index) => {
      const file = findFileByTypeId(context.files, 3);
      return <Component page={page} file={file} index={index} ref={addRef(refs)} key={i++}/>;
    }),
    <Section11.Line15 ref={addRef(refs)} key={i++}/>,
    <Section11.Line16 ref={addRef(refs)} key={i++}/>,
    <Section11.Line17 ref={addRef(refs)} key={i++}/>,
    <Section11.Line18 ref={addRef(refs)} key={i++}/>,
    <Section11.SubHead3 ref={addRef(refs)} key={i++}/>,
    <Section11.Line19 ref={addRef(refs)} key={i++}/>,
    <Section11.Line20 ref={addRef(refs)} key={i++}/>,
    <Section11.Line21 ref={addRef(refs)} key={i++}/>,
    <Section11.Line22 ref={addRef(refs)} key={i++}/>,
    ...getFiles(context, 'קובץ:', 27).map((page, index) => {
      const file = findFileByTypeId(context.files, 27);
      return <Component page={page} file={file} index={index} ref={addRef(refs)} key={i++}/>;
    }),
    <Section11.SubHead4 ref={addRef(refs)} key={i++}/>,
    <Section11.Line24 ref={addRef(refs)} key={i++}/>,
    <Section11.Line25 ref={addRef(refs)} key={i++}/>,
    <Section11.Line26 ref={addRef(refs)} key={i++}/>,
    <Section11.Line27 ref={addRef(refs)} key={i++}/>,
    <Section11.Line28 ref={addRef(refs)} key={i++}/>,
    <Section11.Line29 ref={addRef(refs)} key={i++}/>,
    <Section11.Line30 ref={addRef(refs)} key={i++}/>,
    <Section11.Line31 ref={addRef(refs)} key={i++}/>,
    <Section11.Line32 ref={addRef(refs)} key={i++}/>,
    ...getFiles(context, 'קובץ:', 12).map((page, index) => {
      const file = findFileByTypeId(context.files, 12);
      return <Component page={page} file={file} index={index} ref={addRef(refs)} key={i++}/>;
    }),
    <Section11.SubHeadLine5 ref={addRef(refs)} key={i++}/>,
    <Section11.Line35 ref={addRef(refs)} key={i++}/>,
    <Section11.Line36 ref={addRef(refs)} key={i++}/>,
    <Section11.SubHead6 ref={addRef(refs)} key={i++}/>,
    <Section11.Line37 ref={addRef(refs)} key={i++}/>,
    <Section11.Line38 ref={addRef(refs)} key={i++}/>,
    <Section11.Line39 ref={addRef(refs)} key={i++}/>,
    <Section11.Line40 ref={addRef(refs)} key={i++}/>,
    <Section11.Line41 ref={addRef(refs)} key={i++}/>,
    <Section11.Line42 ref={addRef(refs)} key={i++}/>,
    <Section11.Line43 ref={addRef(refs)} key={i++}/>,
    <Section11.Line44 ref={addRef(refs)} key={i++}/>,
    <Section11.Line45 ref={addRef(refs)} key={i++}/>,
    <Section11.Line46 ref={addRef(refs)} key={i++}/>,
    ...getFiles(context, 'קובץ:', 29).map((page, index) => {
      const file = findFileByTypeId(context.files, 29);
      return <Component page={page} file={file} index={index} ref={addRef(refs)} key={i++}/>;
    }),
    <Section11.SubHead7 ref={addRef(refs)} key={i++}/>,
    <Section11.Line48 ref={addRef(refs)} key={i++}/>,
    <Section11.Line49 ref={addRef(refs)} key={i++}/>,
    <Section11.Line50 ref={addRef(refs)} key={i++}/>,
    <Section11.Line51 ref={addRef(refs)} key={i++}/>,
    <Section11.Line52 ref={addRef(refs)} key={i++}/>,
    <Section11.Line53 ref={addRef(refs)} key={i++}/>,
    <Section11.Line53a ref={addRef(refs)} key={i++}/>,
    ...getFiles(context, 'קובץ:', 28).map((page, index) => {
      const file = findFileByTypeId(context.files, 28);
      return <Component page={page} file={file} index={index} ref={addRef(refs)} key={i++}/>;
    }),
    <Section11.SubHeadLine8 ref={addRef(refs)} key={i++}/>,
    <Section12.Head ref={addRef(refs)} key={i++}/>,
    <Section13.HeadLine1 ref={addRef(refs)} key={i++}/>,
    ...Section13Assets.getSection13(context).map(mapItem({
      refs,
      id: 'Section13Assets.getSection13',
    })),
    <Section13.Line1 ref={addRef(refs)} key={i++}/>,
    <PageBreak ref={addRef(refs)} key={i++}/>,
    <Section14.TableWithHeader ref={addRef(refs)} key={i++}/>,
    <Section14.Line1 ref={addRef(refs)} key={i++}/>,
    <Section15.HeadLine1 ref={addRef(refs)} key={i++}/>,
    <Section15.Line2 ref={addRef(refs)} key={i++}/>,
    <Section15.Line3 ref={addRef(refs)} key={i++}/>,
    <Section15.Line4 ref={addRef(refs)} key={i++}/>,
    <Section15.Line5 ref={addRef(refs)} key={i++}/>,
    <PageBreak ref={addRef(refs)} key={i++}/>,
    <Section15.SubHead23Line6 ref={addRef(refs)} key={i++}/>,
    <Section15.Line7 ref={addRef(refs)} key={i++}/>,
    ...getFiles(context, 'להלן אומדן ההשקעה הצפויה בעלויות הבניה בכל שלב:', 34).map((page, index) => {
      const file = findFileByTypeId(context.files, 34);
      return <Component page={page} file={file} index={index} ref={addRef(refs)} key={i++}/>;
    }),
    <Section15.SubHeadLine4 ref={addRef(refs)} key={i++}/>,
    <Section15.Line10 ref={addRef(refs)} key={i++}/>,
    ...getFiles(context, 'קובץ:', 35).map((page, index) => {
      const file = findFileByTypeId(context.files, 35);
      return <Component page={page} file={file} index={index} ref={addRef(refs)} key={i++}/>;
    }),
    <Section15.Line11 ref={addRef(refs)} key={i++}/>,
    ...getFiles(context, '', 36).map((page, index) => {
      const file = findFileByTypeId(context.files, 36);
      return <Component page={page} file={file} index={index} ref={addRef(refs)} key={i++}/>;
    }),
  ];

  const commentsContent = {
    replacementValue: (
      <Comments.CommentReplacementValueText
        ref={addNoteRef(commentRefs, 'replacementValue')}
        key={i++}
      />
    ),
  };

  return {content, refs, commentsContent, commentRefs};
};

const addRef = refs => element => {
  refs.push(element);
};

const addNoteRef = (refs, id) => {
  const ref = createRef();
  refs[id] = ref;
  return ref;
};